import {createRouter, createWebHistory, RouterView} from 'vue-router'
import Tr from "@/translations"
import i18n from "@/i18n"

import HomeView from '../views/HomeView.vue'
import ArticleDetailsView from '../views/sections/ArticleDetailsView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import PowerTools from '../views/sections/PowerTools.vue'
import Accessories from '../views/sections/Accessories.vue'
import Dealers from '../views/sections/Dealers.vue'
import BestSellers from '../views/sections/BestSellers.vue'
import Novelties from '../views/sections/Novelties.vue'
import Searcher from '../views/sections/Searcher.vue'
import BateriesSystem20V from '../views/sections/BateriesSystem20V.vue'
import DataProtection from '../views/sections/DataProtection'
import HandTools from "@/views/sections/HandTools.vue";
import Chemicals from "@/views/sections/Chemicals.vue";
import StarterKits from "@/views/sections/StarterKits.vue";
import OneForAllTools from "@/views/sections/OneForAllTools.vue";
import BateriesSystem12V from "@/views/sections/BateriesSystem12V.vue";

const routes = [
    {
        path: "/",
        redirect: i18n.global.locale.value
    },
    {
        path: "/:locale",
        name: 'home',
        component: RouterView,
        beforeEnter: Tr.routeMiddleware,
        children: [
            {
                path: '',
                name: 'inicio',
                component: HomeView
            },
            {
                path: 'sistema-de-baterias-intercambiables-20v',
                name: 'BateriesSystem20V',
                component: BateriesSystem20V,
                alias: ['sistema-de-bateries-intercanviables-20v', 'interchangeable-battery-system-20v', 'systeme-de-batterie-interchangeable-20v', 'sistema-de-baterias-intercambiaveis-20v'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'sistema-de-baterias-intercambiables-12v',
                name: 'BateriesSystem12V',
                component: BateriesSystem12V,
                alias: ['sistema-de-bateries-intercanviables-12v', 'interchangeable-battery-system-12v', 'systeme-de-batterie-interchangeable-12v', 'sistema-de-baterias-intercambiaveis-12v'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'herramientas-electricas',
                name: 'PowerTools',
                component: PowerTools,
                alias: ['eines-electriques', 'power-tools', 'outillage-electriques', 'ferramentas-electricas'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'accesorios',
                name: 'Accessories',
                component: Accessories,
                alias: ['accessoris', 'accessories', 'accessoires', 'acessorios'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'los-mas-vendidos',
                name: 'BestSellers',
                component: BestSellers,
                alias: ['els-mes-venuts', 'best-sellers', 'meilleures-ventes', 'os-mais-vendidos'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'novedades',
                name: 'Novelties',
                component: Novelties,
                alias: ['novetats', 'novelties'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'distribuidores',
                name: 'Dealers',
                component: Dealers,
                alias: ['distribuidors', 'dealers', 'distributeurs'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'kits-inicio-one-for-all',
                name: 'StarterKits',
                component: StarterKits,
                alias: ['kits-inici-one-for-all', 'starter-kits-one-for-all', 'kits-de-demarrage-one-for-all', 'kits-de-inicio-one-for-all'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'herramientas-one-for-all',
                name: 'OneForAllTools',
                component: OneForAllTools,
                alias: ['eines-one-for-all', 'one-for-all-tools', 'outils-one-for-all', 'ferramentas-one-for-all'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'proteccion-de-datos',
                name: 'DataProtection',
                component: DataProtection,
                alias: ['proteccio-de-dades', 'data-protection', 'protection-des-donnees', 'protecao-de-dados'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'search/:query',
                name: 'Searcher',
                component: Searcher,
                props: true,
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: ':subcategory/:slug/:id',
                name: 'ArticleDetails',
                component: ArticleDetailsView,
                props: true,
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'herramientas-manuales',
                name: 'HandTools',
                component: HandTools,
                alias: ['hand-tools', 'outils-manuels', 'eines-manuals', 'ferramentas-manuais'],
                meta: {toTop: true, smoothScroll: true}
            },
            {
                path: 'quimicos',
                name: 'Chemicals',
                component: Chemicals,
                alias: ['chemicals', 'produits-chimiques', 'productes-quimics', 'produtos-quimicos'],
                meta: {toTop: true, smoothScroll: true}
            },
        ]
    }
    ,
    {path: '/404', name: 'NotFound', component: NotFoundView},
    {
        path: '/:pathMatch(.*)*',
        beforeEnter() {
            window.location = `/404`
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to) {
        const scroll = {}
        if (to.meta.toTop) scroll.top = 0
        if (to.meta.smoothScroll) scroll.behavior = 'smooth'
        return scroll
    }
})

router.beforeEach((to, from, next) => {
    if (!to.params.locale) {
        to.params.locale = i18n.global.locale.value
    }
    if (to.params.locale === from.params.locale) {
        next()
        return
    }

    const {locale} = to.params

    Tr.switchLanguage(locale)
    next()
})

export default router
